/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import {
  FaSearch,
  FaCalendarAlt,
  FaFilter,
  FaEye,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import Card from "../../components/shared/Card";
import Swal from "sweetalert2";
import { PuffLoader } from "react-spinners";

const PaymentApproval = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    search: "",
    status: "all",
    dateFrom: "",
    dateTo: "",
  });
  const [stats, setStats] = useState({
    pendingCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    totalAmount: 0,
  });

  const loadTransactions = async () => {
    try {
      setTimeout(() => {
        const mockTransactions = [
          {
            id: 12345,
            userId: 101,
            userName: "Gonza",
            email: "gonza@gmail.com",
            phone: "+57 1111111111",
            amount: 250.0,
            referralCode: "REF-CODE",
            date: "2025-03-14",
            status: "pending",
            paymentMethod: "Tarjeta de crédito",
          },
          {
            id: 12345,
            userId: 101,
            userName: "Gonza",
            email: "gonza@gmail.com",
            phone: "+57 1111111111",
            amount: 250.0,
            referralCode: "REF-CODE",
            date: "2025-03-14",
            status: "pending",
            paymentMethod: "Tarjeta de crédito",
          },
          {
            id: 12345,
            userId: 101,
            userName: "Gonza",
            email: "gonza@gmail.com",
            phone: "+57 1111111111",
            amount: 250.0,
            referralCode: "REF-CODE",
            date: "2025-03-14",
            status: "pending",
            paymentMethod: "Tarjeta de crédito",
          },
          {
            id: 12345,
            userId: 101,
            userName: "Gonza",
            email: "gonza@gmail.com",
            phone: "+57 1111111111",
            amount: 250.0,
            referralCode: "REF-CODE",
            date: "2025-03-14",
            status: "pending",
            paymentMethod: "Tarjeta de crédito",
          },
          {
            id: 12345,
            userId: 101,
            userName: "Gonza",
            email: "gonza@gmail.com",
            phone: "+57 1111111111",
            amount: 250.0,
            referralCode: "REF-CODE",
            date: "2025-03-14",
            status: "pending",
            paymentMethod: "Tarjeta de crédito",
          },
          {
            id: 12345,
            userId: 101,
            userName: "Gonza",
            email: "gonza@gmail.com",
            phone: "+57 1111111111",
            amount: 250.0,
            referralCode: "REF-CODE",
            date: "2025-03-14",
            status: "pending",
            paymentMethod: "Tarjeta de crédito",
          },
        ];

        // Filtros
        const filteredTransactions = mockTransactions.filter((transaction) => {
          if (
            filters.status !== "all" &&
            transaction.status !== filters.status
          ) {
            return false;
          }

          // Filtro por búsqueda en nombre, email o teléfono
          if (
            filters.search &&
            !transaction.userName
              .toLowerCase()
              .includes(filters.search.toLowerCase()) &&
            !transaction.email
              .toLowerCase()
              .includes(filters.search.toLowerCase()) &&
            !transaction.phone.includes(filters.search)
          ) {
            return false;
          }

          // Filtro por fecha desde
          if (
            filters.dateFrom &&
            new Date(transaction.date) < new Date(filters.dateFrom)
          ) {
            return false;
          }

          // Filtro por fecha hasta
          if (
            filters.dateTo &&
            new Date(transaction.date) > new Date(filters.dateTo)
          ) {
            return false;
          }

          return true;
        });

        // Calcular estadísticas
        const pendingCount = mockTransactions.filter(
          (t) => t.status === "pending"
        ).length;
        const approvedCount = mockTransactions.filter(
          (t) => t.status === "approved"
        ).length;
        const rejectedCount = mockTransactions.filter(
          (t) => t.status === "rejected"
        ).length;
        const totalAmount = mockTransactions.reduce(
          (sum, t) => sum + t.amount,
          0
        );

        setStats({
          pendingCount,
          approvedCount,
          rejectedCount,
          totalAmount,
        });

        setTransactions(filteredTransactions);
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error al cargar transacciones:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al cargar las transacciones",
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTransactions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    loadTransactions();
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      pending: "badge-table-appoval--warning",
      approved: "badge-table-appoval--success",
      rejected: "badge-table-appoval--error",
    };

    const statusLabels = {
      pending: "Pendiente",
      approved: "Aprobado",
      rejected: "Rechazado",
    };

    return (
      <span className={`badge ${statusClasses[status]}`}>
        {statusLabels[status]}
      </span>
    );
  };

  const handleApprove = (id) => {
    Swal.fire({
      title: "¿Aprobar esta transacción?",
      text: "La transacción será marcada como aprobada",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Sí, aprobar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setTransactions(
          transactions.map((transaction) =>
            transaction.id === id
              ? {
                  ...transaction,
                  status: "approved",
                  approvedAt: new Date().toISOString().split("T")[0],
                  approvedBy: "Admin",
                }
              : transaction
          )
        );

        Swal.fire(
          "¡Aprobado!",
          "La transacción ha sido aprobada correctamente.",
          "success"
        );
      }
    });
  };

  const handleReject = (id) => {
    Swal.fire({
      title: "¿Rechazar esta transacción?",
      text: "Por favor, indique el motivo del rechazo:",
      input: "textarea",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Sí, rechazar",
      cancelButtonText: "Cancelar",
      inputValidator: (value) => {
        if (!value) {
          return "Debe ingresar un motivo para el rechazo";
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setTransactions(
          transactions.map((transaction) =>
            transaction.id === id
              ? {
                  ...transaction,
                  status: "rejected",
                  rejectedAt: new Date().toISOString().split("T")[0],
                  rejectedBy: "Admin",
                  rejectionReason: result.value,
                }
              : transaction
          )
        );

        Swal.fire(
          "¡Rechazado!",
          "La transacción ha sido rechazada correctamente.",
          "success"
        );
      }
    });
  };

  const handleViewDetails = (transaction) => {
    let detailsHtml = `
      <div class="transaction-details">
        ${generateDetail("ID", `#${transaction.id}`)}
        ${generateDetail("Usuario", transaction.userName)}
        ${generateDetail("Email", transaction.email)}
        ${generateDetail("Teléfono", transaction.phone)}
        ${generateDetail("Código de Referido", transaction.referralCode)}
        ${generateDetail("Monto", `$${transaction.amount.toFixed(2)}`)}
        ${generateDetail("Método de Pago", transaction.paymentMethod)}
        ${generateDetail("Fecha", formatDate(transaction.date))}
        ${generateDetail(
          "Estado",
          transaction.status === "pending"
            ? "Pendiente"
            : transaction.status === "approved"
            ? "Aprobado"
            : "Rechazado"
        )}
    `;

    if (transaction.status === "approved") {
      detailsHtml += `
        ${generateDetail(
          "Fecha de Aprobación",
          formatDate(transaction.approvedAt)
        )}
        ${generateDetail("Aprobado por", transaction.approvedBy)}
      `;
    } else if (transaction.status === "rejected") {
      detailsHtml += `
        ${generateDetail(
          "Fecha de Rechazo",
          formatDate(transaction.rejectedAt)
        )}
        ${generateDetail("Rechazado por", transaction.rejectedBy)}
        ${generateDetail("Motivo del Rechazo", transaction.rejectionReason)}
      `;
    }

    detailsHtml += `</div>`;

    Swal.fire({
      title: "Detalles de la Transacción",
      html: detailsHtml,
      width: 600,
      confirmButtonText: "Cerrar",
    });
  };

  // Función auxiliar para generar los detalles
  const generateDetail = (label, value) => {
    return `
      <div class="detail">
        <span class="key"><strong>${label}:</strong></span>
        <span class="value">${value}</span>
      </div>
    `;
  };

  if (loading) {
    return (
      <div className="loader-container">
        <PuffLoader
          color="#009ee3"
          loading={true}
          size={60}
          margin={2}
          speedMultiplier={4}
        />
      </div>
    );
  }

  return (
    <div className="payment-approval-container">
      <h1 className="payment-approval__title">Aprobación de Pagos</h1>

      {/* Tarjetas de estadísticas */}
      <div className="payment-approval__stats">
        <Card className="stat-card">
          <div className="stat-card__label">Pagos Pendientes</div>
          <div className="stat-card__value">{stats.pendingCount}</div>
        </Card>
        <Card className="stat-card">
          <div className="stat-card__label">Pagos Aprobados</div>
          <div className="stat-card__value">{stats.approvedCount}</div>
        </Card>
        <Card className="stat-card">
          <div className="stat-card__label">Pagos Rechazados</div>
          <div className="stat-card__value">{stats.rejectedCount}</div>
        </Card>
        <Card className="stat-card">
          <div className="stat-card__label">Monto Total</div>
          <div className="stat-card__value">
            ${stats.totalAmount.toFixed(2)}
          </div>
        </Card>
      </div>

      {/* Filtros */}
      {/* <Card className="payment-approval__filters-card">
        <form
          className="payment-approval__filters"
          onSubmit={handleFilterSubmit}
        >
          <div className="form-group">
            <label htmlFor="search" className="form-label">
              Usuario
            </label>
            <div className="input-group">
              <FaSearch className="input-icon" />
              <input
                type="text"
                id="search"
                name="search"
                className="form-control"
                placeholder="Buscar"
                value={filters.search}
                onChange={handleFilterChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="status" className="form-label">
              Estado
            </label>
            <div className="input-group">
              <FaFilter className="input-icon" />
              <select
                id="status"
                name="status"
                className="form-control"
                value={filters.status}
                onChange={handleFilterChange}
              >
                <option value="all">Todos los estados</option>
                <option value="pending">Pendiente</option>
                <option value="approved">Aprobado</option>
                <option value="rejected">Rechazado</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="dateFrom" className="form-label">
              Fecha desde
            </label>
            <div className="input-group">
              <FaCalendarAlt className="input-icon" />
              <input
                type="date"
                id="dateFrom"
                name="dateFrom"
                className="form-control"
                value={filters.dateFrom}
                onChange={handleFilterChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="dateTo" className="form-label">
              Fecha hasta
            </label>
            <div className="input-group">
              <FaCalendarAlt className="input-icon" />
              <input
                type="date"
                id="dateTo"
                name="dateTo"
                className="form-control"
                value={filters.dateTo}
                onChange={handleFilterChange}
              />
            </div>
          </div>

          <div className="form-group submit-group">
            <button type="submit" className="button button--w100-btn   ">
              Filtrar
            </button>
          </div>
        </form>
      </Card> */}

      {/* Tabla de Transacciones */}
      <Card className="payment-approval__table-card">
        <div className="payment-approval__table">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Usuario</th>
                <th>Monto</th>
                <th>Método</th>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length === 0 ? (
                <tr>
                  <td colSpan="7" className="no-data">
                    No hay transacciones que coincidan con los filtros
                  </td>
                </tr>
              ) : (
                transactions.map((transaction) => (
                  <tr key={transaction.id}>
                    <td>#{transaction.id}</td>
                    <td>{transaction.userName}</td>
                    <td className="amount">${transaction.amount.toFixed(2)}</td>
                    <td>{transaction.paymentMethod}</td>
                    <td>{formatDate(transaction.date)}</td>
                    <td>{getStatusBadge(transaction.status)}</td>
                    <td className="actions-cell">
                      {transaction.status === "pending" && (
                        <>
                          <button
                            className="btn btn-small btn-success"
                            onClick={() => handleApprove(transaction.id)}
                            title="Aprobar pago"
                          >
                            <FaCheckCircle /> Aprobar
                          </button>
                          <button
                            className="btn btn-small btn-danger"
                            onClick={() => handleReject(transaction.id)}
                            title="Rechazar pago"
                          >
                            <FaTimesCircle /> Rechazar
                          </button>
                        </>
                      )}
                      <button
                        className="btn btn-small btn-view"
                        onClick={() => handleViewDetails(transaction)}
                        title="Ver detalles"
                      >
                        <FaEye /> Detalles
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Paginación */}
      {/* <div className="payment-approval__pagination">
        <ul className="pagination">
          <li className="pagination-item">
            <a href="#" className="pagination-link">
              &laquo;
            </a>
          </li>
          <li className="pagination-item">
            <a href="#" className="pagination-link active">
              1
            </a>
          </li>
          <li className="pagination-item">
            <a href="#" className="pagination-link">
              2
            </a>
          </li>
          <li className="pagination-item">
            <a href="#" className="pagination-link">
              3
            </a>
          </li>
          <li className="pagination-item">
            <a href="#" className="pagination-link">
              &raquo;
            </a>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default PaymentApproval;
